import { FC } from 'react';
import { TaskContentBox } from './shared/taskContentBox';

export const ExportsPage: FC = () => {
  return <TaskContentBox type="export" />;
};
